import { useQuery } from "@tanstack/react-query";

import { GET_USERS_SESSION_QUERY_KEY } from "./query-keys";
import useUserSessionApi from "./user-sessions-api";

export default function useGetUserSession() {
  const api = useUserSessionApi();

  const fetchMethod = async () => {
    return api.getUserSession();
  };

  return useQuery({
    queryKey: [GET_USERS_SESSION_QUERY_KEY],
    queryFn: fetchMethod,
  });
}
